import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const HeroSection = ({ onGetStarted, onLogin, onStudentLogin }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-12 md:py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="text-center lg:text-left stagger-fade-in">
            <div className="inline-flex items-center justify-center lg:justify-start mb-6 lg:mb-8">
              <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-primary/10 rounded-2xl flex items-center justify-center">
                <Icon name="BookOpen" size={40} className="text-primary md:w-12 md:h-12 lg:w-14 lg:h-14" />
              </div>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
              Create Interactive Learning Experiences
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-6 md:mb-8 max-w-2xl mx-auto lg:mx-0">
              Empower your students with AI-powered educational content. Design multimedia learning trails, generate QR codes for physical trails, and track progress with comprehensive analytics.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button
                size="lg"
                iconName="Sparkles"
                iconPosition="left"
                onClick={onGetStarted}
                className="w-full sm:w-auto">
                
                Get Started
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="LogIn"
                iconPosition="left"
                onClick={onLogin}
                className="w-full sm:w-auto">
                
                Teacher Login
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="GraduationCap"
                iconPosition="left"
                onClick={onStudentLogin}
                className="w-full sm:w-auto">
                
                Student Login
              </Button>
            </div>

            <div className="mt-8 md:mt-10 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center text-sm text-muted-foreground">
                <Icon name="Shield" size={18} className="text-success mr-2" />
                <span>SSL Secured</span>
              </div>
              <div className="flex items-center text-sm text-muted-foreground">
                <Icon name="Award" size={18} className="text-success mr-2" />
                <span>Made for Educators</span>
              </div>
              <div className="flex items-center text-sm text-muted-foreground">
                <Icon name="Users" size={18} className="text-success mr-2" />
                <span>Designed for Young Learners</span>
              </div>
            </div>
          </div>

          <div className="relative stagger-fade-in stagger-delay-1">
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <Image
                src="https://img.rocket.new/generatedImages/rocket_gen_img_130036a4d-1766558305587.png"
                alt="Modern classroom with diverse group of elementary students engaged in interactive learning activities using tablets and educational materials on wooden desks"
                className="w-full h-64 md:h-80 lg:h-96 object-cover" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
            </div>

            <div className="absolute -bottom-4 -right-4 md:-bottom-6 md:-right-6 bg-card rounded-xl shadow-lg p-4 md:p-6 max-w-xs stagger-fade-in stagger-delay-2">
              <div className="flex items-start">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-success/10 rounded-lg flex items-center justify-center mr-3 md:mr-4">
                  <Icon name="TrendingUp" size={24} className="text-success" />
                </div>
                <div>
                  <p className="text-xs md:text-sm text-muted-foreground">Student Engagement</p>
                  <p className="text-lg md:text-2xl font-bold text-foreground">+85%</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;